import { connect } from 'react-redux'

import Salary from '../../components/salary/salary.component'
import { convertToZeroTime } from '../../utils/salary.utils'

import {
  getSalariesStart,
  getSalaryInfo,
  salaryPageChange,
  getAdminUsersList,
  loadProfileStart,
  closeSalaryPayError,
  updateTaxCard,
  getUserCompanyUpdateInfo
} from '../../actions'

const mapStateToProps = (state) => {
  const { client } = state
  const userType = client.user.data[5]
  const allSalaries = state.salary.allSalaries.map((item) => ({
    ...item,
    // toDate need to be converted to zero time to avoid time comparison with datepicker time value
    toDate: convertToZeroTime(item.created) // Add this property to make the filter dateTo
  }))
  return {
    state,
    salaryRows: state.salary.salaryRows,
    salaryPages: !!state.salary.allSalaries
      ? Math.ceil(state.salary.allSalaries.length / 10)
      : 0,
    id: state.salary.newSalaryInfo.id,
    invoice_uuid: state.salary.newSalaryInfo.invoice_uuid,
    userType,
    accountStatus: state.salary.accountStatus,
    allSalaries: allSalaries,
    selectedUser: state.adminUser.selectedUser
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getSalariesStart: (data) => dispatch(getSalariesStart(data)),
    getSalaryInfo: (id) => dispatch(getSalaryInfo(id)),
    salaryPageChange: (selected) => dispatch(salaryPageChange(selected)),
    getAdminUsersList: () => dispatch(getAdminUsersList()),
    loadProfileStart: () => dispatch(loadProfileStart()),
    closeSalaryPayError: () => dispatch(closeSalaryPayError()),
    updateTaxCard: () => dispatch(updateTaxCard()),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo())
  }
}

const SalaryContainer = connect(mapStateToProps, mapDispatchToProps)(Salary)

export default SalaryContainer
